module.exports = __webpack_public_path__ + "static/media/own-sample.e909b20b.svg";